import { usePolicyContext } from "../Contexts/AddPolicyContext";
import { baseUrl } from "../utilities/configurations";
import { useAuth } from "../Contexts/AuthContext";
import apiRequest from "../utilities/request";
import { useState, useEffect } from "react";
import SuccessModal from "./SuccessModal";
import PropTypes from "prop-types";
import Button from "./Button";

const UnlinkPolicyModal = ({ onSuccess }) => {
  const { setIsLoading, selectedPolicy, setShowModal } = usePolicyContext();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { setUserData } = useAuth();

  const getPolicy = async () => {
    try {
      const res = await apiRequest(baseUrl + `/policy/policies`, "GET");

      if (res && !res.error) {
        setUserData(res.data || []);
      } else {
        console.log("Failed to load");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPolicy();
  }, []);

  const handleUnlinkConfirm = async () => {
    setIsLoading(true);

    try {
      const response = await apiRequest(
        baseUrl + `/policy/unlink-policy`,
        "POST",
        {
          cardNo: selectedPolicy.cardNo,
        }
      );

      if (response && response.status === true) {
        setShowSuccessModal(true);
      } else {
        console.log("Failed to unlink policy:", response);
      }
    } catch (err) {
      console.log("Error during API request:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setShowSuccessModal(false);
    setShowModal(false);
    if (onSuccess) onSuccess(); // Trigger the callback if provided
  };

  return (
    <div
      style={{ top: 0, left: 0, bottom: 0, right: 0 }}
      className="flex flex-col items-center justify-center min-h-screen max-w-screen fixed bg-black bg-opacity-20 backdrop-blur-md z-50 lg:pl-[240px]"
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="w-full flex flex-col">
          <div className="font-semibold text-lg text-[#1F2328]">
            Confirm unlinking of policy
          </div>

          <div className="w-full mt-1">
            <div>
              Are you sure you want to unlink the{" "}
              <p
                style={{ display: "inline" }}
                className="font-semibold text-sm"
              >
                Tertiary policy
              </p>
              ? Unlinking it will result in the loss of access to the following:
            </div>
          </div>

          <div className="w-full mt-1">
            <div className="container mx-auto ml-2">
              <ul className="list-disc list-inside">
                <li>Associated medical records</li>
                <li>Any policy-related benefits</li>
                <li>Historical claim data</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-row mt-5">
          <Button
            className="w-full h-10 rounded-xl font-semibold bg-white text-[#383F49] border-2 border-[#D6D7D8] transition ease-in-out delay-75 hover:scale-105 ml-2"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>

          <Button
            className="w-full h-10 rounded-xl font-semibold text-white transition ease-in-out delay-75 hover:scale-105 ml-2"
            onClick={handleUnlinkConfirm}
          >
            Yes, unlink
          </Button>
        </div>
      </div>

      {showSuccessModal && (
        <SuccessModal
          isOpen={showSuccessModal}
          title={"Policy successfully unlinked"}
          body={
            "The policy you selected has been successfully unlink from this account"
          }
          onClick={handleClose}
        />
      )}
    </div>
  );
};

UnlinkPolicyModal.propTypes = {
  onSuccess: PropTypes.func,
};

export default UnlinkPolicyModal;
